import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { Table } from 'react-bootstrap';

const ItemDokumenPpsComp = (props) => {
  // console.log(props);
  return (
    <Table striped bordered hover>
      <thead className="bg-primary border-1 text-center text-white">
        <tr>
          <th width="200px">
            <b>Langkah Pemenuhan</b>
          </th>
          <th width="200px">
            <b>Metode Perbaikan</b>
          </th>
          <th width="200px">
            <b>Indikator Pencapaian</b>
          </th>
          <th width="150px">
            <b>Kategori Perbaikan</b>
          </th>
          <th width="100px">
            <b>PIC</b>
          </th>
        </tr>
      </thead>
      <tbody className="border-1">
        <tr>
          <td className="text-center">{props?.itemsdokumen?.langkahPemenuhan}</td>
          <td className="text-center">{props?.itemsdokumen?.metodePerbaikan}</td>
          <td className="text-center">{props?.itemsdokumen?.indikatorPencapaian}</td>
          <td className="text-center">
            {props?.itemsdokumen?.kategoriPerbaikan}
          </td>
          <td className="text-center">{props?.itemsdokumen?.pic}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default ItemDokumenPpsComp;
